import * as React from 'react';
import Result from "./Result";
import { VolumetricParameter, FlowParameter, DiffusingCapacityParameter, PressureParameter } from './PFTAPITypes';
export interface BestResultProps {
    result: VolumetricParameter | FlowParameter | DiffusingCapacityParameter | PressureParameter;
    isLoading?: boolean;
}
export default class BestResult extends React.PureComponent<BestResultProps> {
    render() {
        return (
            <td data-automationid={`best-result-${this.props.result.ParameterType}`}>
                <Result isLoading={this.props.isLoading} parameter={this.props.result} />
            </td>
        );
    }
}